import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { languageReducer } from '@shared/api/reduxToolkit';
import { LANGUAGE_KEY } from '@shared/constants';

const languagePersistConfig = {
	key: LANGUAGE_KEY,
	version: 1,
	storage,
	whitelist: ['currentLanguage'],
};

export const persistedLanguageReducer = persistReducer(languagePersistConfig, languageReducer);
